export const getters = {
  getProfile: state => state.profile,
  getProfileLoadingStatus: state => state.profileLoadingStatus,
  getMaritalStatusData: state => state.maritalStatus,
  getMaritalStatusLoadingStatus: state => state.maritalStatusLoadingStatus,
  getAddress: state => state.address,
  isTheResidenceOwner: state => state.address.isTheResidenceOwner,
  getAddressLoadingStatus: state => state.addressLoadingStatus,
  getComplianceStatus: state => state.complianceStatus,
  getComplianceStatusLoadingStatus: state => state.complianceStatusLoadingStatus,
  getLevy: state => state.levy,
  getAmountOwedItems: state => state.amountOwedItems,
  getTotalAmountOwed: state => state.amountOwedItems.reduce((acc, item) => acc + item.amount, 0),
  getAmountOwedLoadingStatus: state => state.amountOwedLoadingStatus,
  getAmountOwedYears: state => state.amountOwedYears,
  getClaimedDependents: state => state.claimedDependents,
  getClaimedDependentsLoadingStatus: state => state.claimedDependentsLoadingStatus,
  getCountiesOfState: state => state.countiesOfState,
};
